import {
  Box,
  ChakraProps,
  CloseButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useBreakpointValue,
} from '@chakra-ui/react'

import { scrollCSS } from 'src/lib/utils'

type ModalProps = {
  onClose: () => void
  children: React.ReactNode
  isOpen: boolean
  showHeader?: boolean
  title?: string
} & ChakraProps

function InContextModalFrame({
  children,
  onClose,
  isOpen,
  showHeader = true,
  title,
  ...props
}: ModalProps) {
  const modalSize = useBreakpointValue({ sm: 'full', md: 'md' })
  if (modalSize === undefined) return null
  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent
        my={0}
        maxH="calc(100vh - 32px)"
        borderRadius={24}
        overflow="hidden"
        mx={4}
        containerProps={{ overflow: 'hidden' }}
        {...props}
      >
        <>
          {showHeader && (
            <>
              <ModalHeader
                position="absolute"
                left={0}
                right={0}
                zIndex="sticky"
                bg="white"
                borderRadius="32x 32x 0 0"
                h="64px"
              >
                <CloseButton
                  variant="boxModal"
                  onClick={onClose}
                  position="absolute"
                  top={4}
                  left={5}
                />
                {!!title && (
                  <Box as="h4" textAlign="center" className="thick">
                    {title}
                  </Box>
                )}
              </ModalHeader>
              <ModalBody pt={16} overflow="auto" {...scrollCSS}>
                {children}
              </ModalBody>
            </>
          )}
          {!showHeader && <>{children}</>}
        </>
      </ModalContent>
    </Modal>
  )
}

export default InContextModalFrame
